
// newsapiorg.js
    class NewsAPIManager {
        constructor() {
            this.apiKey = null;
        }

        async initialize() {
        }

        async fetchApiKey() {
            try {
                const response = await fetch('/api/config');
                if (!response.ok) throw new Error(`Failed to fetch /api/config: ${response.status}`);
                const config = await response.json();
                if (!config.NEWS_API_KEY) throw new Error('NEWS_API_KEY not found in /api/config');
                //console.log('NewsAPIManager initialized, API key:', config.NEWS_API_KEY.slice(0, 4) + '...');
                return config.NEWS_API_KEY;
            } catch (error) {
                console.error('Error fetching API key:', error.message);
                throw error;
            }
        }

        static async create() {
            if (!NewsAPIManager.instance) {
                const instance = new NewsAPIManager();
                await instance.initialize();
                NewsAPIManager.instance = instance;
            }
            return NewsAPIManager.instance;
        }

        async fetchStockNews(stockSymbol, limit = 10, startDate = null, endDate = null) {
            try {
                let url = `/proxy-news?symbol=${encodeURIComponent(stockSymbol)}&limit=${limit}`;

                if (startDate) url += `&from=${startDate}`; // NewsAPI uses from/to, not published_utc.gte/lte
                if (endDate) url += `&to=${endDate}`;

                console.log(`📡 Fetching news for ${stockSymbol} from NewsAPI.org...`, url);

                const response = await fetch(url);
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

                const jsonData = await response.json();
                if (!jsonData.articles || !Array.isArray(jsonData.articles)) { // NewsAPI uses "articles", not "results"
                    console.warn(`❌ No news data available or invalid 'articles' field for ${stockSymbol}.`);
                    return [];
                }

                const newsArticles = jsonData.articles.map(article => ({
                    title: article.title || "No title available",
                    publisher: article.source.name || "Unknown publisher", // NewsAPI uses source.name, not publisher.name
                    publishedDate: article.publishedAt || new Date().toISOString(), // publishedAt, not published_utc
                    url: article.url || "#", // url, not article_url
                    description: article.description || "",
                    tickers: [stockSymbol] // NewsAPI doesn’t provide tickers, so we use the queried symbol
                }));

                console.log(`✅ Retrieved ${newsArticles.length} news articles for ${stockSymbol} from NewsAPI.org.`);
                return newsArticles;
            } catch (error) {
                console.error(`❌ Error fetching news for ${stockSymbol}: ${error.message}`);
                return [];
            }
        }
    }

window.NewsAPIManager = NewsAPIManager;